module.exports = __webpack_public_path__ + "img/1440.c18843d3.jpg";